import bgBG from './translations/bg-BG.json'
import deDE from './translations/de-DE.json'
import enUs from './translations/en-US.json'
import es419 from './translations/es-419.json'
import esES from './translations/es-ES.json'
import frCA from './translations/fr-CA.json'
import frFR from './translations/fr-FR.json'
import hi from './translations/hi.json'
import itIT from './translations/it-IT.json'
import nlBE from './translations/nl-BE.json'
import ptBR from './translations/pt-BR.json'
import ptPT from './translations/pt-PT.json'
import th from './translations/th.json'
import vi from './translations/vi.json'
import zhCN from './translations/zh-CN.json'

export const translations = {
  'bg-BG': bgBG,
  'en-US': enUs,
  'de-DE': deDE,
  'es-419': es419,
  'es-ES': esES,
  'fr-CA': frCA,
  'fr-FR': frFR,
  hi: hi,
  'it-IT': itIT,
  'nl-BE': nlBE,
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  th: th,
  vi: vi,
  'zh-CN': zhCN
}

export { default as AdaptiveCard } from './components/AdaptiveCardRenderer/AdaptiveCard'
export { default as DetailAdaptiveCard } from './components/AdaptiveCardRenderer/DetailAdaptiveCard'
export { default as DetailWrapper } from './components/DetailWrapper/DetailWrapper'

export { default as dateFnsLocales } from './translations/dateFnsLocales'
